import React from "react";
import CountdownTimer from "./CountdownTimer";
import RevealNumbers from "./RevealNumbers";

const ResultImagePanel = ({
  title,
  draw,
  imageUrl,
  loading,
  message,
  onDownload,
  onShare,
  featured = false,
}) => {
  const tickerText = `${draw.label} result update is being checked automatically. Please stay connected for the official result image and PDF download.`;

  return (
    <article className={`result-panel ${featured ? "result-panel-featured" : ""}`}>
      <div className="result-panel-head">
        <div>
          <span className="eyebrow">Live result desk</span>
          <h2>{title}</h2>
        </div>
        <span className="draw-badge" style={{ "--accent": draw.accent }}>
          {draw.label}
        </span>
      </div>

      {/* {React.createElement(RevealNumbers, { seed: `${draw.key}-${title}` })} */}
      <CountdownTimer compact />

      <div className="result-document" id="imageContainer">
        {loading ? (
          <div className="result-skeleton" aria-label="Loading result">
            <span />
            <span />
            <span />
          </div>
        ) : imageUrl ? (
          <img
            src={imageUrl}
            alt={`${title} ${draw.label} result`}
            width="768"
            height="1071"
            className="result-image"
            loading={featured ? "eager" : "lazy"}
          />
        ) : (
          <div className="result-empty result-news-alert" role="status" aria-live="polite">
            <span className="news-label">Breaking Update</span>
            <strong>{message || `${draw.label} result is coming shortly`}</strong>
            <span>
              Stay on this page. We are checking for the official result automatically.
            </span>
            <div className="result-ticker" aria-label={tickerText}>
              <div className="result-ticker-track">
                <span>{tickerText}</span>
                <span>{tickerText}</span>
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="result-actions">
        <button type="button" className="premium-button" onClick={onDownload}>
          Download PDF
        </button>
        <button type="button" className="premium-button secondary" onClick={onShare}>
          Share Result
        </button>
      </div>
    </article>
  );
};

export default ResultImagePanel;
